import { useState, useEffect } from "react";
import { fetchSimilarPitchers } from "../../../services/player-service";

export const useSimilarPitchers = ({ playerId, year, division }) => {
  const [similarPlayers, setSimilarPlayers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [player, setPlayer] = useState("");
  const [note, setNote] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!playerId || !year || !division) return;

    const controller = new AbortController();

    (async () => {
      setIsLoading(true);
      setSimilarPlayers([]);
      setPlayer("");
      setNote("");
      setError(null);

      try {
        const response = await fetchSimilarPitchers(playerId, year, division, controller.signal);
        if (controller.signal.aborted) return;
        setPlayer(response.target_player.player_name || "");
        setSimilarPlayers(response.similar_players || []);
        setNote(response.note || "");
      } catch (err) {
        if (err?.name === "AbortError") return;
        setError("Could not load similar pitchers");
      } finally {
        if (!controller.signal.aborted) setIsLoading(false);
      }
    })();

    return () => controller.abort();
  }, [playerId, year, division]);

  return { similarPlayers, isLoading, player, note, error };
};
